<template>
  <div>
    <div class="intro">
      <h2>Jouw voortgang</h2>
      <p class="light">Deze pagina bevat jouw ingevulde weegmomenten en toont jouw progressie in een grafiek. Probeer je
        altijd te wegen op hetzelfde moment op de dag voor een goede vergelijking.</p>
    </div>

    <Spinner v-if="loading"/>

    <div v-else>
      <WeightGraph
          :weights="weights"
      />

      <SetWeightForm
          @created='init()'
      />

      <WeightOverview
          :weights="reverseWeights"
          @updated='init()'
      />
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import Spinner from "../blocks/Spinner.vue";
import WeightOverview from "./weights/WeightOverview.vue";
import SetWeightForm from "./weights/SetWeightForm.vue";
import WeightGraph from "./weights/WeightGraph.vue";

export default {
  name: "Progress",
  data() {
    return {
      weights: [],
      reverseWeights: [],
      loading: true,
    };
  },
  components: {
    SetWeightForm,
    WeightOverview,
    Spinner,
    WeightGraph
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("weight", [
      "getWeights",
    ]),
    init() {
      this.getWeights().then(response => {
        this.weights = response;
        if (response) {
          this.reverseWeights = response.slice().reverse(); // Flip safely
        }
        this.loading = false;
      });
    },
  },
};
</script>
